import _getJobs from "@fuze/apis-foundry/dist/jobs/functions/getJobs"

import { wrapFoundryFunctionWithoutOrganizationPaginated } from "./decorators"

export const getJobs = (filter, pagination) =>
  wrapFoundryFunctionWithoutOrganizationPaginated(_getJobs)(filter, pagination)
